import { Space } from '@fullstory/proto/fs/services/dx-objects';

export const HOME_SPACE_ID = 'home';
export const PRIVATE_SPACE_ID = 'private_library';

export const PRIVATE_SPACE: Space = {
  id: PRIVATE_SPACE_ID,
  name: '',
  description: '',
  color: '#FFD700',
  isDefault: false,
  recentViewers: [],
  orgId: '',
  lastUpdated: null,
};

export const PSEUDO_SPACES = [HOME_SPACE_ID, PRIVATE_SPACE_ID];
